import { permissionsInstanceSetup } from './permissionsChecker';
export async function checkPermissions({ resource, action }) {
    const permissionInstance = permissionsInstanceSetup.getInstance();
    if (!permissionInstance) {
        throw new Error('Error: permissionInstance not initialized!');
    }
    try {
        const hasPermission = await permissionInstance.checkPermission(resource, action);
        return hasPermission;
    }
    catch (err) {
        console.error('Error: permissionInstance ', err);
        throw err;
    }
}
//# sourceMappingURL=checkPermissions.js.map